import React from 'react';
import PropTypes from 'prop-types';
import { compose, lifecycle, getContext } from 'recompose';
import './MicroFrontEndEmbed.scss';

// Minimal DOM helpers inlined from reactfoot's utils/dom/dom
function createElementWithAttributes(tag, attributes) {
	const element = document.createElement(tag);
	Object.keys(attributes || {}).forEach((key) => {
		element[key] = attributes[key];
	});
	return element;
}

function createStylesheetElement(attributes) {
	return createElementWithAttributes('link', {
		rel: 'stylesheet',
		...attributes,
	});
}

function createScriptElement(attributes) {
	return createElementWithAttributes('script', {
		type: 'text/javascript',
		...attributes,
	});
}

export const enhance = compose(
	getContext(),
	lifecycle({
		componentDidMount() {
			const { id, scriptURL, stylesheetURL, onLoad, onError, config } =
				this.props;

			if (config) {
				window.__MFE_CONFIG__ = window.__MFE_CONFIG__ || {};
				window.__MFE_CONFIG__[id] = config;
			}

			const handleOnLoad = () => {
				if (onLoad) onLoad();
			};

			const handleOnError = () => {
				if (onError) onError();
			};

			if (stylesheetURL) {
				const linkEl = createStylesheetElement({
					id: `${id}-stylesheet`,
					href: stylesheetURL,
				});
				document.head.appendChild(linkEl);
			} else {
				return handleOnError();
			}

			const scriptEl = createScriptElement({
				id,
				src: scriptURL,
				onload: handleOnLoad,
				onerror: handleOnError,
				async: true,
				crossorigin: 'anonymous',
			});
			document.body.appendChild(scriptEl);
		},
		componentWillUnmount() {
			const { id } = this.props;

			if (window.__MFE_CONFIG__ && id in window.__MFE_CONFIG__) {
				delete window.__MFE_CONFIG__[id];
			}

			const scriptEl = document.getElementById(id);
			if (scriptEl) scriptEl.remove();

			const linkEl = document.getElementById(`${id}-stylesheet`);
			if (linkEl) linkEl.remove();
		},
	}),
);

export const MicroFrontEndEmbed = ({ id, className, data }) => (
	<div
		className={className}
		id={id}
		{...data}
	/>
);

MicroFrontEndEmbed.propTypes = {
	className: PropTypes.string,
	id: PropTypes.string,
	data: PropTypes.object,
};

export default enhance(MicroFrontEndEmbed);
